import React from "react";
import './LoaderDots.css'

const Loaderdots = () => {
  return (
    <div className="loader-dots-container">
      <div className="loader"></div>
      <div>
        {" "}
        {/* <h3 class="data-loading">Data Loading</h3> */}
        </div> 
    </div>
  );
};

export default Loaderdots;
